export default "__VITE_ASSET__D65E6XEK__"